
    import '/opt/buildhome/repo/components/x-request/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["components-x-request-demo-basic","components-x-request-demo-requestparams","components-x-request-demo-custom-transformer","components-x-request-demo-request-options","components-x-request-demo-model"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/x-request/index.zh-CN.md?type=demo')
};